<template>
  <section id="portada" class="animacion">
    <div class="contedor-portada">
      <div class="portada-contenido animacion">
        <h1>{{ subSectionData.nom_sub_sec_es }}</h1>
        <ul>
          <li><router-link tag="a" to="/">Inicio</router-link></li>
          <li class="sin-division">{{ subSectionData.nom_sub_sec_es }}</li>
        </ul>
      </div>
      <img
        class="imagen-cover"
        v-bind:src="imgPreUrl + subSectionData.url_1st_image + 'x640.jpg'"
        v-bind:alt="subSectionData.type_1st_image"
      />
    </div>
  </section>
</template>
<script>
import { config_settings } from '@/config.js';

export default {
  name: 'SubSectionBanner',
  props: ['subSectionData'],
  data() {
    return {
      imgPreUrl: config_settings.PHOTO_SERVER_URL + '/',
    };
  },
};
</script>
